// Core
import { call, put } from 'redux-saga/effects';

// Instruments
import { reviewsActions as actions } from 'bus/reviews/actions';
import { getTurpravdaHotelInformer } from '@otpusk/json-api';

export function* getTurpravdaReviewsWorker ({ payload: hotelId }) {
    try {
        const reviewsHtml = yield call(getTurpravdaHotelInformer, hotelId);

        yield put(actions.getTurpravdaReviewsSuccess(hotelId, reviewsHtml));
    } catch (error) {
        console.error(error);
        yield put(actions.getTurpravdaReviewsFail(error));
    }
}
